/* eslint-disable no-underscore-dangle */
/* eslint-disable @typescript-eslint/no-var-requires */
/* eslint-disable global-require */
import {
  createStore,
  combineReducers,
  applyMiddleware,
  compose,
  Store,
} from 'redux';
import createSagaMiddleware from 'redux-saga';
import { reducers as ducksReducers, createSaga } from '@app/redux/ducks-loader';
import { RootState } from '../types';
import attachInitialStateToWindow from './utils/attachInitialStateToWindow';

const composeEnhancers =
  (typeof window !== 'undefined' &&
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) ||
  compose;

let store: Store<RootState>;

export const getStore = ({ req }) => {
  // If store exists, return it
  if (store) {
    return store;
  }

  // Otherwise, create it
  const initialState =
    window?.__INITIAL_REDUX_STATE__ ??
    req?.appContext?.states?.redux?.value ??
    {};

  //
  // 3rd party script QuantumMetic expects this value to exist.
  if (!window?.__INITIAL_REDUX_STATE__) {
    attachInitialStateToWindow(initialState);
  }

  const combinedReducers = {
    ...ducksReducers,
  };

  const sagaMiddleware = createSagaMiddleware();
  const middlewares = [sagaMiddleware];

  store = createStore(
    combineReducers(combinedReducers),
    initialState,
    composeEnhancers(applyMiddleware(...middlewares)),
  );
  const rootSaga = createSaga();
  sagaMiddleware.run(rootSaga);

  return store;
};

export default getStore;
